import request from "@/utils/request"; // 引入request,基于axios
import queryString from "querystring"; // post方法传参转型String

export function getDetail(data) {
  return request({
    url: `/enjoyment-server/app/user/answer/` + data.id + `/report`,
    method: "get",
    data: data,
  });
}

export function recommendation(data) {
  return request({
    url: `/enjoyment-server/app/assessment/` + data.id + `/recommendation`,
    method: "post",
    data: data,
  });
}
export function getRecommend(data) {
  return request({
    url: `/enjoyment-server/app/assessment/` + data.id + `/recommendation`,
    method: "get",
    data: data,
  });
}

export function getReportRecommend(data) {
      return request({
        url: `/enjoyment-server/app/assessment/` + data.id + `/popular`,
        method: "get",
        data: data,
      });
    }

export function getTreeDetail(imageId) {
  return request({
    url: `/multi-model-server/fsr/reports/${imageId}`,
    method: "post",
  });
}

// 获取房树人图片
export function getTreeImage(data) {
  return request({
    url: `/res-server/file/play-url`,
    method: "post",
    data: data,
  });
}